/** @fileoverview Two summary cards: total Standards / Skills assessed. */

import { Paper, SimpleGrid, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

interface DevelopmentReportStatsProps {
  readonly standardsAssessed: number
  readonly skillsAssessed: number
}

const VALUE_COLOR = 'var(--mantine-color-blue-6, #228be6)'

export function DevelopmentReportStats({ standardsAssessed, skillsAssessed }: DevelopmentReportStatsProps) {
  const { t } = useTranslation()

  const items = [
    { key: 'standards', value: standardsAssessed, label: t('development_report.stats.standards_assessed') },
    { key: 'skills', value: skillsAssessed, label: t('development_report.stats.skills_assessed') },
  ]

  return (
    <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]} spacing='md'>
      {items.map(item => (
        <Paper key={item.key} withBorder radius='md' p='lg'>
          <Stack spacing={4}>
            <Text size={32} weight={700} style={{ color: VALUE_COLOR, lineHeight: 1.1 }}>
              {item.value}
            </Text>
            <Text color='dimmed'>{item.label}</Text>
          </Stack>
        </Paper>
      ))}
    </SimpleGrid>
  )
}
